import React, { useState } from "react";
import { Button, Modal, Input, Form, Alert, notification, message } from "antd";
import { connect } from "react-redux";
import serviceMail from "../services/sendmail";
import moment from "moment";
import ConvertKitSubscribeForm from "./ConvertKitSubscribeForm";
import { checkExistUrl, createRequest } from "../actions/reQuest";
import "./content.css";
import "./contentTwo.scss";
import { Philosophy } from "./HomeSections/Philosophy";
import { LearnMore } from "./HomeSections/LearnMore";
import { Mission } from "./HomeSections/Mission";
import { About } from "./HomeSections/About";
import { Subscriptions } from "./HomeSections/Subscriptions";
import { EarlyAccess } from "./HomeSections/EarlyAccess";
const urlTail = ".shell.genchealth.com";

function Content(props) {
  const [modalVisible, handleShowHideModal] = useState(false);
  const [currentFormName, setCurrentFormName] = useState("");
  const [modalVisibleRequest, handleShowHideModalRequest] = useState(false);
  const [firstNameUrl, setFirsNameUrl] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showMessageSuccess, setShowMessageSucess] = useState(false);
  function handleConvertKitForm(event, formName) {
    event.preventDefault();
    setCurrentFormName(formName);
    handleShowHideModal(true);
  }

  function renderModal() {
    return (
      <Modal
        visible={modalVisible}
        footer={[]}
        onCancel={() => handleShowHideModal(false)}
      >
        <ConvertKitSubscribeForm formName={currentFormName} />
      </Modal>
    );
  }

  function handleSendMail(Subject, Message, from, to) {
    const data = {
      from,
      to,
      subject: Subject,
      html: Message,
    };
    serviceMail.sendMail(data);
  }

  function onFinish(values) {
    if (firstNameUrl === "") {
      message.warn("url is not valid");
    } else {
      setShowMessage(false);
      checkExistUrl(firstNameUrl).then((result) => {
        const { isExist } = result;
        setShowMessage(true);
        if (!isExist) {
          setShowMessageSucess(true);
          const data = {
            ...values,
            firstNameUrl,
            status: "pending",
          };
          createRequest(data).then((result) => {
            const { isSuccess } = result;
            if (isSuccess) {
              notification.success({
                message: "Actions",
                description: "Your request to GenC Healh Successfully",
              });

              const subject = `${values.firstName} try to request page at GenC Health-Box.`;
              const content = `<h3>${values.firstName}</h3><div>Email: ${
                values.email
              }</div><div> Try to message you at ${moment().format(
                "ll"
              )}</div>`;

              handleSendMail(subject, content, values.email, [
                "philiptranp@gmail.com",
                "support@angelo.network",
                "cuongseven789@gmail.com",
              ]);
              handleShowHideModalRequest(false);
            } else {
              notification.error({
                message: "Actions",
                description: "Your request to GenC Healh fail",
              });
            }
          });
        } else {
          setShowMessageSucess(false);
        }
      });
    }
  }

  function renderModalRequest() {
    return (
      <Modal
        visible={modalVisibleRequest}
        footer={[]}
        title="CREATE UNIQUE URL TO ACCESS YOUR GenC Health-Box"
        onCancel={() => handleShowHideModalRequest(false)}
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={(values) => {
            onFinish(values);
          }}
        >
          <Form.Item
            label="First Name"
            name="firstName"
            onChange={(e) => {
              const { value } = e.target;
              setFirsNameUrl(value);
            }}
            rules={[
              { required: true, message: "Please input your first name!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please input your email!" },
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          YOUR UNIQUE URL:{" "}
          {firstNameUrl !== "" ? (
            <div style={{ marginBottom: "20px" }}>
              {firstNameUrl}
              {urlTail}
            </div>
          ) : null}
          <div style={{ marginBottom: "20px" }}>
            {showMessage ? (
              <>
                {showMessageSuccess ? (
                  <Alert
                    message="CONGRATULATIONS URL IS AVAILABLE"
                    type="success"
                    showIcon
                    closable
                  />
                ) : (
                  <Alert
                    message="URL IS NOT AVAILABLE, PLEASE PICK A NEW URL"
                    type="warning"
                    showIcon
                    closable
                  />
                )}
              </>
            ) : null}
          </div>
          <div style={{ display: "flex", marginBottom: "20px" }}>
            <Input
              onChange={(e) => {
                const { value } = e.target;
                setFirsNameUrl(value);
              }}
              style={{ width: "100px" }}
              size="small"
              value={firstNameUrl}
            />
            <div>{urlTail}</div>
            <Button
              onClick={() => {
                setShowMessage(false);
                checkExistUrl(firstNameUrl).then((result) => {
                  const { isExist } = result;
                  setShowMessage(true);
                  if (!isExist) {
                    setShowMessageSucess(true);
                  } else {
                    setShowMessageSucess(false);
                  }
                });
              }}
              style={{
                marginLeft: "10px",
                backgroundColor: "#ff5c03",
                borderColor: "#ff5c03",
                color: "#ff5c03",
              }}
              type="primary"
              shape="round"
              size="small"
              ghost
            >
              Check
            </Button>
          </div>
          <div></div>
          <div style={{ width: "100%", textAlign: "center" }}>
            <Button
              style={{
                backgroundColor: "#ff5c03",
                borderColor: "#ff5c03",
                color: "#fff",
              }}
              shape="round"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }

  return (
    <>
      {modalVisible && renderModal()}
      {modalVisibleRequest && renderModalRequest()}
      {/* <section className="content-about" id="About">
        <div className="header-text">
          <h2 className="heading-2" style={{ color: "white" }}>
            Help Mothers collect, store, and connect health data (i.e. activity
            data generated from smartphones and wearable devices) to useful apps
            and models to improve children health &nbsp;
          </h2>
        </div>
      </section> */}
      <EarlyAccess />
      <About
        handleShowHideModalRequest={(e) => {
          e.preventDefault();
          handleShowHideModalRequest(true);
        }}
      />

      <LearnMore />
      <Mission />
      <Philosophy />
      <Subscriptions
        handleSampleNotif={(e) => {
          e.preventDefault();
          props.history.push("/Member-Notifications/detail");
        }}
        handleMemberSub={(e, n) => handleConvertKitForm(e, "member-subscribe")}
        handleLatestUpdate={(e) => {
          e.preventDefault();
          props.history.push("/GenC-Labs/detail");
        }}
        handleShareholderSub={(e, n) =>
          handleConvertKitForm(e, "shareholder-subscribe")
        }
        handleLatestNews={(e) => {
          e.preventDefault();
          props.history.push("/Developer-Newsletter/detail");
        }}
        handleNewsSub={(e, n) => handleConvertKitForm(e, "developer-subscribe")}
        handleLatestSnacks={(e) => {
          e.preventDefault();
          props.history.push("/GenC-Snacks/detail");
        }}
        handleSnacksSub={(e, n) => handleConvertKitForm(e, "genc-snacks")}
      />
      {/* <Subscriptions /> */}
      {/* <section className="content-section" id="Welcome">
        <div className="content-wrapper w-container">
          <div className="header-text">
            <div className="title" style={{ fontSize: 18 }}>
              YOUR FAMILY ONLINE HEALTH-BOX
            </div>
            <h2 className="heading-2">
              Decentralized and private data containers&nbsp;
              <span className="thin">
                for you and your loved ones to secure, connect, and model health
                data
              </span>
            </h2>
          </div>
          <div className="flex-wrapper space-between">
            <div
              className="feature-box"
              data-ix="up-icon-on-hover"
              style={{
                opacity: 1,
                transform: "translateX(0px) translateY(0px) translateZ(0px)",
                transition: "opacity 500ms ease 0s, transform 500ms ease 0s",
              }}
            >
              <div className="icon-bg">
                <img
                  className="features-icon rocket"
                  width={150}
                  src={dataPrivacyIcon}
                  alt="Blue email icon"
                  style={{
                    paddingTop: "10px",
                    transformStyle: "preserve-3d",
                    transition:
                      "transform 750ms ease 0s, opacity 750ms ease 0s",
                    opacity: 1,
                    transform:
                      "translateX(0px) translateY(0px) translateZ(0px)",
                  }}
                />
              </div>
              <h4>
                <span>Secure & Private</span>
              </h4>
              <p>
                Built with Hybrid-blockchain Technology and strictly adhere to
                Zero-knowledge Server Protocols means your health data are
                impossible to access by anyone else but you and your apps.
              </p>
            </div>
            <div
              className="browser-icon feature-box"
              data-ix="bounce-icon-on-hover"
              style={{
                opacity: 1,
                transform: "translateX(0px) translateY(0px) translateZ(0px)",
                transition: "opacity 500ms ease 0s, transform 500ms ease 0s",
              }}
            >
              <div className="design icon-bg">
                <img
                  className="features-icon screen"
                  width={100}
                  src={affordableIcon}
                  alt="affordable"
                  style={{
                    transformStyle: "preserve-3d",
                    transition:
                      "transform 750ms ease 0s, opacity 750ms ease 0s",
                    transform:
                      "translateX(0px) translateY(0px) translateZ(0px)",
                    opacity: 1,
                  }}
                />
              </div>
              <h4>Affordable</h4>
              <p>
                Storing files on the Blockchain is secure but expensive. GenC
                helps bringing the cost down so that you and Generation C users
                can afford to store heavy files such as X-rays or even videos
              </p>
            </div>
            <div
              className="feature-box heart"
              data-ix="scale-up-icon-on-hover"
              style={{
                opacity: 1,
                transform: "translateX(0px) translateY(0px) translateZ(0px)",
                transition: "opacity 500ms ease 0s, transform 500ms ease 0s",
              }}
            >
              <div className="code icon-bg">
                <img
                  className="code features-icon"
                  width={100}
                  src={computableIcon}
                  alt="Finger click"
                  style={{
                    paddingTop: "15px",
                    transformStyle: "preserve-3d",
                    transition:
                      "transform 450ms ease 0s, opacity 750ms ease 0s",
                    transform: "scaleX(1) scaleY(1) scaleZ(1)",
                    opacity: 1,
                  }}
                />
              </div>
              <h4>Computable</h4>
              <p>
                Your health database grows as you age. Computability means your
                data can be connected to your selected apps and train your AI
                agents to assist you mininizing the ill-effects of aging.
              </p>
            </div>
          </div>
          {/* <a
            onClick={(e) => {
              e.preventDefault();
              handleShowHideModalRequest(true);
            }}
            className="button top-border upgrade-link"
            href="#upgrade-form"
          >
            REQUEST A FREE GENC SHELL SANDBOX
          </a> 

          <div style={{ justifyContent: "center", display: "flex" }}>
            <MainButton
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              text={"Request a FREE Geb C Shell Sandbox"}
              onClick={(e) => {
                e.preventDefault();
                handleShowHideModalRequest(true);
              }}
            />
          </div>
        </div>
      </section>
      <section className="content-3">
        <div className="header-text">
          <div className="title" style={{ fontSize: 18 }}>
            GENC APPS & MODELS FOR HEALTH - AM HEALTH STORE
          </div>
          <h2 className="heading-2" style={{ color: "white" }}>
            GenC Shell is not just a highly secure storage box,&nbsp;
            <span className="thin">
              it is also a database that you can connect to your subscribed apps
              and recommended machine learning models or AIs -{" "}
              <span style={{ fontWeight: 500 }}>
                your modern health personal assistants.
              </span>
            </span>
          </h2>
          <p style={{ fontSize: 18, color: "white" }}>
            <a
              href="assets/file/angelo_network.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <span style={{ color: "#1890ff", cursor: "pointer" }}>
                Learn more
              </span>
            </a>{" "}
            about the technologies behind GenC Health-Box and AM Health Store.
          </p>
        </div>
      </section> */}

      {/* <section className="content-2 ">
         <div className="header-text" style={{ marginTop: "50px" }}>
          <div className="title" style={{ fontSize: 18 }}>
            DELIVERING HAPPINESS
          </div>
          <h2 className="heading-2">
            From the very first members to the future Generation C,&nbsp;
            <span className="thin">
              we are striving to build a delivering happiness culture that is
              conducive to health and wellbeing for all. So subscribe, tune in,
              and{" "}
              <span style={{ fontWeight: 500 }}>
                help us to serve you and the future Gen C
              </span>
              .
            </span>
          </h2>
        </div> 

        <div className="row" style={{ margin: "unset" }}>
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
            id="list-box-3"
            data-tags="technology politics business entertainment lifestyle"
          >
            <div className="infobox text-center">
              <div className="flip-container ">
                <div className="flipper">
                  <div className="front">
                    <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                      <img alt="member notifs" src={notifyIcon} />
                    </figure>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                      <h3>
                        <a href="/daily">Member Notifications</a>
                      </h3>
                      <p>
                        Members subcribe to GenC Health Notifications for
                        updates about the latest membership info, GenC Data
                        Shell new features, available apps and models.
                      </p>
                      <p>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/Member-Notifications/detail");
                          }}
                          className="orange underlined"
                          href="/campaigns/inside-daily-brief-2020-08-03-23967"
                        >
                          <strong>
                            <u>Sample notifications</u>
                          </strong>
                        </a>
                      </p>
                      <div className="tags">
                        <b>ASAP</b>
                      </div>
                    </div>
                    <div className="list-subscription-action">
                      <Button
                        data-remote="true"
                        data-disable-with="Opening ..."
                        className="col-xs-12 btn btn-default btn-susbcr"
                        onClick={(e, n) =>
                          handleConvertKitForm(e, "member-subscribe")
                        }
                      >
                        <i className="fa fa-envelope ico ico-env" /> Subscribe
                        <img
                          className="ico ico-arrow"
                          src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                          alt="Ico arrow gray"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
            id="list-box-3"
            data-tags="technology politics business entertainment lifestyle"
          >
            <div className="infobox text-center">
              <div className="flip-container ">
                <div className="flipper">
                  <div className="front">
                    <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                      <img alt="GenC Updates " src={updateIcon} />
                    </figure>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                      <h3>
                        <a href="/daily">GenC Labs Inc. Updates</a>
                      </h3>
                      <p>
                        Shareholders subscribe to GenC Labs Inc. newsletter for
                        press releases, GenC platform development milestones,
                        and corporate news.
                      </p>
                      <p>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/GenC-Labs/detail");
                          }}
                          className="orange underlined"
                          href="/campaigns/inside-daily-brief-2020-08-03-23967"
                        >
                          <strong>
                            <u>Latest update</u>
                          </strong>
                        </a>
                      </p>
                      <div className="tags">
                        <b>WEEKLY</b>
                      </div>
                    </div>
                    <div className="list-subscription-action">
                      <Button
                        data-remote="true"
                        data-disable-with="Opening ..."
                        className="col-xs-12 btn btn-default btn-susbcr"
                        onClick={(e, n) =>
                          handleConvertKitForm(e, "shareholder-subscribe")
                        }
                      >
                        <i className="fa fa-envelope ico ico-env" /> Subscribe
                        <img
                          className="ico ico-arrow"
                          src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                          alt="Ico arrow gray"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
            id="list-box-3"
            data-tags="technology politics business entertainment lifestyle"
          >
            <div className="infobox text-center">
              <div className="flip-container ">
                <div className="flipper">
                  <div className="front">
                    <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                      <img alt="Developer newsletter" src={developerIcon} />
                    </figure>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                      <h3>
                        <a href="/daily">Developer Newsletter</a>
                      </h3>
                      <p>
                        Developers subscribe to GenC App Store and ML Model
                        related tutorials, software development training, and
                        job opportunities.
                      </p>
                      <p>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/Developer-Newsletter/detail");
                          }}
                          className="orange underlined"
                          href="/campaigns/inside-daily-brief-2020-08-03-23967"
                        >
                          <strong>
                            <u>Latest issue</u>
                          </strong>
                        </a>
                      </p>
                      <div className="tags">
                        <b>WEEKLY</b>
                      </div>
                    </div>
                    <div className="list-subscription-action">
                      <Button
                        data-remote="true"
                        data-disable-with="Opening ..."
                        className="col-xs-12 btn btn-default btn-susbcr"
                        onClick={(e, n) =>
                          handleConvertKitForm(e, "developer-subscribe")
                        }
                      >
                        <i className="fa fa-envelope ico ico-env" /> Subscribe
                        <img
                          className="ico ico-arrow"
                          src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                          alt="Ico arrow gray"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-3 col-md-6 col-sm-6 col-xs-12 continfobox"
            id="list-box-3"
            data-tags="technology politics business entertainment lifestyle"
          >
            <div className="infobox text-center">
              <div className="flip-container ">
                <div className="flipper">
                  <div className="front">
                    <figure className="col-lg-5 col-md-5 col-sm-12 col-xs-12 img-circle">
                      <img alt="GenC Snacks Newsletter" src={gencSnacksIcon} />
                    </figure>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 info">
                      <h3>
                        <a href="/daily">GenC Snacks</a>
                      </h3>
                      <p>
                        The 3-minute newsletter with fresh takes on the health,
                        fitness, healthcare, and health-tech news you need to
                        start your day.
                      </p>
                      <p>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push("/GenC-Snacks/detail");
                          }}
                          className="orange underlined"
                          href="/campaigns/inside-daily-brief-2020-08-03-23967"
                        >
                          <strong>
                            <u>Latest issue</u>
                          </strong>
                        </a>
                      </p>
                      <div className="tags">
                        <b>DAILY</b>
                      </div>
                    </div>
                    <div className="list-subscription-action">
                      <Button
                        data-remote="true"
                        data-disable-with="Opening ..."
                        className="col-xs-12 btn btn-default btn-susbcr"
                        onClick={(e, n) =>
                          handleConvertKitForm(e, "genc-snacks")
                        }
                      >
                        <i className="fa fa-envelope ico ico-env" /> Subscribe
                        <img
                          className="ico ico-arrow"
                          src="https://inside.com//assets/web/ico-arrow-gray-ccce20fba87a4b789849696785ba3840e240aaf30233bba4668f82b3309787ae.png"
                          alt="Ico arrow gray"
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default connect(null, null)(Content);
